import React from 'react';
import moment from 'moment';
import Helmet from 'react-helmet';
import { Box, Grid, Hidden } from '@material-ui/core';
import DayPickerInput from 'react-day-picker/DayPickerInput';
// import 'react-day-picker/lib/style.css';
import '../../../node_modules/react-day-picker/lib/style.css';
import EmailIcon from '@material-ui/icons/Email';

import { formatDate, parseDate } from 'react-day-picker/moment';
import { withStyles } from '@material-ui/core';
import BodyText from './BodyText';
import {
	setDepart,
	setOrigin,
	setOriginO,
	setDepartO,
} from '../../reducers/UiReducer';
const styles = (theme) => ({
	root: {
		'& .InputFromTo': {
			'& .DayPickerInput input': {
				padding: '17px 0px',
				width: '100%',
				// ['@media screen and (min-width: 600px) and (max-width: 740px)']: {
				// 	width: '87%',
				// },
				// ['@media screen and (min-width: 740px) and (max-width: 800px)']: {
				// 	width: '90%',
				// },
				// ['@media screen and (min-width: 800px) and (max-width: 900px)']: {
				// 	width: '91%',
				// },
			},
			'& .DayPickerInput': {
				width: '100%',
			},
		},
	},
});
class Example extends React.Component {
	constructor(props) {
		super(props);
		this.handleFromChange = this.handleFromChange.bind(this);
		this.handleToChange = this.handleToChange.bind(this);
		this.state = {
			from: undefined,
			to: undefined,
		};
	}

	showFromMonth() {
		const { from, to } = this.state;
		if (!from) {
			return;
		}
		if (moment(to).diff(moment(from), 'months') < 2) {
			this.to.getDayPicker().showMonth(from);
		}
	}

	handleFromChange(from) {
		// Change the from date and focus the "to" input field
		this.setState({ from });
	}
	convert(str) {
		var date = new Date(str),
			mnth = ('0' + (date.getMonth() + 1)).slice(-2),
			day = ('0' + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join('-');
	}
	handleToChange(to) {
		this.setState({ to }, this.showFromMonth);
	}

	render() {
		const { from, to } = this.state;
		const modifiers = { start: from, end: to };
		const { classes } = this.props;
		// console.log(from);
		// {
		// 	from ? console.log(new Date(from).toISOString()) : '';
		// }
		console.log(this.convert(from));
		console.log(from);
		this.props.dispatch(setOrigin(this.convert(from)));
		this.props.dispatch(setOriginO(from));
		this.props.dispatch(setDepart(this.convert(to)));
		this.props.dispatch(setDepartO(to));
		console.log(this.convert(to));

		// const v = 'Wed Feb 02 2022 12:00:00 GMT+0530 (India Standard Time)';
		// let date = moment(new Date(v.substr(0, 16)));
		// console.log(date);
		return (
			<div className={classes.root}>
				<div className='InputFromTo' style={{ display: 'flex' }}>
					<Grid container spacing={this.props.matches ? 2 : ''}>
						<Grid item xs={12} sm={6} lg={6}>
							<DayPickerInput
								value={from}
								placeholder='From'
								format='LL'
								formatDate={formatDate}
								parseDate={parseDate}
								dayPickerProps={{
									selectedDays: [from, { from, to }],
									disabledDays: { after: to },
									toMonth: to,
									modifiers,
									numberOfMonths: 2,
									onDayClick: () => this.to.getInput().focus(),
								}}
								onDayChange={this.handleFromChange}
							/>{' '}
						</Grid>
						<Grid item xs={12} sm={6} lg={6}>
							<span className='InputFromTo-to'>
								<DayPickerInput
									ref={(el) => (this.to = el)}
									value={to}
									placeholder={'Return'}
									format='LL'
									formatDate={formatDate}
									parseDate={parseDate}
									dayPickerProps={{
										selectedDays: [from, { from, to }],
										disabledDays: { before: from },
										modifiers,
										month: from,
										fromMonth: from,
										numberOfMonths: 2,
									}}
									onDayChange={this.handleToChange}
								/>
							</span>
						</Grid>
					</Grid>

					{/* <span style={{ color: 'white', marginTop: 20 }}>— </span> */}

					<Hidden only={['xs']}>
						<Helmet>
							<style>{`
  .InputFromTo .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #4a90e2;
  }
  .InputFromTo .DayPicker-Day {
    border-radius: 0 !important;
  }
  .InputFromTo .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .InputFromTo .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  .InputFromTo .DayPickerInput-Overlay {
    width: 550px;
  }
  .InputFromTo-to .DayPickerInput-Overlay {
    margin-left: -198px;
  }
`}</style>
						</Helmet>
					</Hidden>
				</div>
			</div>
		);
	}
}
export default withStyles(styles)(Example);
